import { Role, SettableRole } from '../../model/Roles';

const en = {
  labels: {
    [Role.ADMIN]: 'Administrator',
    [Role.NEWS_WRITE]: 'News Editor',
    [Role.PAGES_WRITE]: 'Pages Editor',
    [Role.ADVERTISEMENTS_WRITE]: 'Advertisements Editor',
    [Role.NOTIFICATION_PUSH]: 'Notifications',
    [Role.CARPOOLS]: 'Carpools admin',
    [Role.CARPOOLS_VIEWER]: 'Carpools viewer',
    [Role.MODERATOR]: 'Moderator',
  } as Record<SettableRole, string>,
  descriptions: {
    [Role.ADMIN]: 'Everything, users included',
    [Role.NEWS_WRITE]: 'Writes and edits news',
    [Role.PAGES_WRITE]: 'Writes and edits the info pages',
    [Role.ADVERTISEMENTS_WRITE]: 'Manages the ads shown when the app opens',
    [Role.NOTIFICATION_PUSH]: 'Sends push notifications',
    [Role.CARPOOLS]: 'Sees and deletes carpools',
    [Role.CARPOOLS_VIEWER]: 'Sees carpools',
    [Role.MODERATOR]: 'Handles reported carpools',
  } as Record<SettableRole, string>,
  /** Roles the Users tab doesn't give, which older accounts may have */
  otherLabels: {
    [Role.NEWS_READ]: 'News (read only)',
    [Role.PAGES_READ]: 'Pages (read only)',
    [Role.ADVERTISEMENTS_READ]: 'Advertisements (read only)',
    [Role.MODERATOR_CARPOOLS]: 'Carpool moderator',
  } as Record<string, string>,
};

const fr: typeof en = {
  labels: {
    [Role.ADMIN]: 'Administrateur',
    [Role.NEWS_WRITE]: 'Rédaction des actus',
    [Role.PAGES_WRITE]: 'Rédaction des pages',
    [Role.ADVERTISEMENTS_WRITE]: 'Gestion des publicités',
    [Role.NOTIFICATION_PUSH]: 'Notifications',
    [Role.CARPOOLS]: 'Gestion des covoiturages',
    [Role.CARPOOLS_VIEWER]: 'Lecture des covoiturages',
    [Role.MODERATOR]: 'Modération',
  },
  descriptions: {
    [Role.ADMIN]: 'Tout, y compris les utilisateurs',
    [Role.NEWS_WRITE]: 'Rédige et modifie les actus',
    [Role.PAGES_WRITE]: 'Rédige et modifie les pages d\'infos',
    [Role.ADVERTISEMENTS_WRITE]: 'Gère les publicités affichées à l\'ouverture de l\'app',
    [Role.NOTIFICATION_PUSH]: 'Envoie des notifications push',
    [Role.CARPOOLS]: 'Voit et supprime les covoiturages',
    [Role.CARPOOLS_VIEWER]: 'Voit les covoiturages',
    [Role.MODERATOR]: 'Traite les covoiturages signalés',
  },
  otherLabels: {
    [Role.NEWS_READ]: 'Actus (lecture seule)',
    [Role.PAGES_READ]: 'Pages (lecture seule)',
    [Role.ADVERTISEMENTS_READ]: 'Publicités (lecture seule)',
    [Role.MODERATOR_CARPOOLS]: 'Modération des covoiturages',
  },
};

const messages = { en, fr };
export default messages;
